// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { AiFormAepFragmentDoc } from '../../../../components/formFields/ai/utils/aiProposalForm.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageElevationsV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageElevationsV2Query = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, displayCode?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, options: Array<{ __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, programDatas: Array<{ __typename?: 'ReadyPlanProgramData', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } }>, programData: { __typename?: 'ProgramData', id: string, netBuildableSqft?: number | null | undefined, grossBuildableSqft?: number | null | undefined, grossBelowGroundSqft?: number | null | undefined, sellableAboveGroundSqft?: number | null | undefined, sellableBelowGroundSqft?: number | null | undefined, imperviousSqft?: number | null | undefined, buildingHeightInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, unfinishedBelowGroundSqft?: number | null | undefined } }>, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity:
          | { __typename: 'MaterialListing', id: string }
          | { __typename: 'MaterialVariant', id: string }
          | { __typename: 'ReadyPlanLocation', id: string }
          | { __typename: 'ReadyPlanOption', id: string }
          | { __typename: 'ReadyPlanProgramData', id: string }
          | { __typename: 'TakeoffLineItem', id: string }
        , fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined } };

export type ElevationCatalogV2QueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ElevationCatalogV2Query = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', id: string, code: string, name: string }> };

export type SavePlanPackageElevationMutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type SavePlanPackageElevationMutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, displayCode?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, options: Array<{ __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, programDatas: Array<{ __typename?: 'ReadyPlanProgramData', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } }>, programData: { __typename?: 'ProgramData', id: string, netBuildableSqft?: number | null | undefined, grossBuildableSqft?: number | null | undefined, grossBelowGroundSqft?: number | null | undefined, sellableAboveGroundSqft?: number | null | undefined, sellableBelowGroundSqft?: number | null | undefined, imperviousSqft?: number | null | undefined, buildingHeightInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, unfinishedBelowGroundSqft?: number | null | undefined } }>, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity:
            | { __typename: 'MaterialListing', id: string }
            | { __typename: 'MaterialVariant', id: string }
            | { __typename: 'ReadyPlanLocation', id: string }
            | { __typename: 'ReadyPlanOption', id: string }
            | { __typename: 'ReadyPlanProgramData', id: string }
            | { __typename: 'TakeoffLineItem', id: string }
          , fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined } } };

export type PlanPackageElevationsV2_AiProposalFragment = { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity:
        | { __typename: 'MaterialListing', id: string }
        | { __typename: 'MaterialVariant', id: string }
        | { __typename: 'ReadyPlanLocation', id: string }
        | { __typename: 'ReadyPlanOption', id: string }
        | { __typename: 'ReadyPlanProgramData', id: string }
        | { __typename: 'TakeoffLineItem', id: string }
      , fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined };

export type PlanPackageElevationsV2_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, globalOption: { __typename?: 'GlobalOption', id: string }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, programDatas: Array<{ __typename?: 'ReadyPlanProgramData', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined } }>, programData: { __typename?: 'ProgramData', id: string, netBuildableSqft?: number | null | undefined, grossBuildableSqft?: number | null | undefined, grossBelowGroundSqft?: number | null | undefined, sellableAboveGroundSqft?: number | null | undefined, sellableBelowGroundSqft?: number | null | undefined, imperviousSqft?: number | null | undefined, buildingHeightInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, unfinishedBelowGroundSqft?: number | null | undefined } };

export const PlanPackageElevationsV2_AiProposalFragmentDoc = gql`
    fragment PlanPackageElevationsV2_AiProposal on PlanPackage {
  id
  aiProposal {
    id
    entityProposals(entityType: [ELEVATION]) {
      ...AiFormAep
    }
  }
}
    ${AiFormAepFragmentDoc}`;
export const PlanPackageElevationsV2_ReadyPlanOptionFragmentDoc = gql`
    fragment PlanPackageElevationsV2_ReadyPlanOption on ReadyPlanOption {
  ...Named
  code
  order
  active
  type {
    id
    isElevation
  }
  globalOption {
    id
  }
  optionImage {
    id
    previewUrl(resizing: {width: 800, region: FULL})
  }
  assets {
    id
    active
    isCoverPhoto
    asset {
      id
      previewUrl(resizing: {width: 800, region: FULL})
    }
  }
  programDatas {
    id
    readyPlanOptions {
      id
    }
    programData {
      id
      sellableSqft
    }
  }
  programData {
    id
    netBuildableSqft
    grossBuildableSqft
    grossBelowGroundSqft
    sellableAboveGroundSqft
    sellableBelowGroundSqft
    imperviousSqft
    buildingHeightInFeet
    widthInFeet
    depthInFeet
    sellableSqft
    unfinishedBelowGroundSqft
  }
}
    ${NamedFragmentDoc}`;
export const PlanPackageElevationsV2Document = gql`
    query PlanPackageElevationsV2($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    id
    displayCode
    version {
      id
    }
    canEdit {
      ...PotentialOperationDetails
    }
    options {
      ...PlanPackageElevationsV2_ReadyPlanOption
    }
    ...PlanPackageElevationsV2_AiProposal
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${PlanPackageElevationsV2_ReadyPlanOptionFragmentDoc}
${PlanPackageElevationsV2_AiProposalFragmentDoc}`;

/**
 * __usePlanPackageElevationsV2Query__
 *
 * To run a query within a React component, call `usePlanPackageElevationsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageElevationsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageElevationsV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageElevationsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables> & ({ variables: PlanPackageElevationsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>(PlanPackageElevationsV2Document, options);
      }
export function usePlanPackageElevationsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>(PlanPackageElevationsV2Document, options);
        }
// @ts-ignore
export function usePlanPackageElevationsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>;
export function usePlanPackageElevationsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageElevationsV2Query | undefined, PlanPackageElevationsV2QueryVariables>;
export function usePlanPackageElevationsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>(PlanPackageElevationsV2Document, options);
        }
export type PlanPackageElevationsV2QueryHookResult = ReturnType<typeof usePlanPackageElevationsV2Query>;
export type PlanPackageElevationsV2LazyQueryHookResult = ReturnType<typeof usePlanPackageElevationsV2LazyQuery>;
export type PlanPackageElevationsV2SuspenseQueryHookResult = ReturnType<typeof usePlanPackageElevationsV2SuspenseQuery>;
export type PlanPackageElevationsV2QueryResult = ApolloReactCommon.QueryResult<PlanPackageElevationsV2Query, PlanPackageElevationsV2QueryVariables>;
export const ElevationCatalogV2Document = gql`
    query ElevationCatalogV2 {
  globalOptions(filter: {isElevation: true, version: [2]}) {
    id
    code
    name
  }
}
    `;

/**
 * __useElevationCatalogV2Query__
 *
 * To run a query within a React component, call `useElevationCatalogV2Query` and pass it any options that fit your needs.
 * When your component renders, `useElevationCatalogV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useElevationCatalogV2Query({
 *   variables: {
 *   },
 * });
 */
export function useElevationCatalogV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>(ElevationCatalogV2Document, options);
      }
export function useElevationCatalogV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>(ElevationCatalogV2Document, options);
        }
// @ts-ignore
export function useElevationCatalogV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>;
export function useElevationCatalogV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ElevationCatalogV2Query | undefined, ElevationCatalogV2QueryVariables>;
export function useElevationCatalogV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>(ElevationCatalogV2Document, options);
        }
export type ElevationCatalogV2QueryHookResult = ReturnType<typeof useElevationCatalogV2Query>;
export type ElevationCatalogV2LazyQueryHookResult = ReturnType<typeof useElevationCatalogV2LazyQuery>;
export type ElevationCatalogV2SuspenseQueryHookResult = ReturnType<typeof useElevationCatalogV2SuspenseQuery>;
export type ElevationCatalogV2QueryResult = ApolloReactCommon.QueryResult<ElevationCatalogV2Query, ElevationCatalogV2QueryVariables>;
export const SavePlanPackageElevationDocument = gql`
    mutation SavePlanPackageElevation($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      id
      displayCode
      version {
        id
      }
      canEdit {
        ...PotentialOperationDetails
      }
      options {
        ...PlanPackageElevationsV2_ReadyPlanOption
      }
      ...PlanPackageElevationsV2_AiProposal
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${PlanPackageElevationsV2_ReadyPlanOptionFragmentDoc}
${PlanPackageElevationsV2_AiProposalFragmentDoc}`;

/**
 * __useSavePlanPackageElevationMutation__
 *
 * To run a mutation, you first call `useSavePlanPackageElevationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageElevationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageElevationMutation, { data, loading, error }] = useSavePlanPackageElevationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanPackageElevationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageElevationMutation, SavePlanPackageElevationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageElevationMutation, SavePlanPackageElevationMutationVariables>(SavePlanPackageElevationDocument, options);
      }
export type SavePlanPackageElevationMutationHookResult = ReturnType<typeof useSavePlanPackageElevationMutation>;
export type SavePlanPackageElevationMutationResult = ApolloReactCommon.MutationResult<SavePlanPackageElevationMutation>;